import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiSendMailTitle } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiSendMailTitleDialogData {
  send_mail_titles?: ApiSendMailTitle[];
}

@Component({
  selector: 'app-multi-send-mail-title-dialog',
  templateUrl: './multi-send-mail-title-dialog.component.html',
  styleUrls: ['./multi-send-mail-title-dialog.component.css'],
  standalone: false,
})
export class MultiSendMailTitleDialogComponent implements OnInit {

  //名称×言語数
  sendMailTitles: ApiSendMailTitle[] = [];
  sendMailTitlesFormGroup!: FormGroup;
  sendMailTitlesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiSendMailTitleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiSendMailTitleDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.sendMailTitles = this.data.send_mail_titles!;
    if (!this.sendMailTitles) {
      this.sendMailTitles = [];
    }
    this.createForm();
    this.sendMailTitlesArrayControl = this.sendMailTitlesFormGroup.get('sendMailTitles') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.sendMailTitlesFormGroup.disable();
    }
  }

  //名称フォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.sendMailTitles.length > 0 ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let send_mail_title = '';
      let trans_send_mail_title = '';
      for (const value of this.sendMailTitles) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          send_mail_title = value.send_mail_title;
          trans_send_mail_title = value.trans_send_mail_title;
          break
        }
      }
      let _dict = {};
      if (index === 0) {
        _dict = {
          autoTrans: [auto_trans],
          sendMailTitle: [send_mail_title, [Validators.required]],
          transSendMailTitle: [trans_send_mail_title],
        }
      } else {
        _dict = {
          autoTrans: [auto_trans],
          sendMailTitle: [send_mail_title],
          transSendMailTitle: [],
        }
      }
      arrayControl.push(this.formBuilder.group(_dict));
      index++;
    }
    this.sendMailTitlesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        sendMailTitles: arrayControl
      }
    );
  }

  //更新ボタン
  addSendMailTitles(): void {
    if (this.sendMailTitlesFormGroup.valid) {
      let sendMailTitles = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.sendMailTitlesArrayControl.controls[index];
        sendMailTitles.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            send_mail_title: ctrl.get('sendMailTitle')!.value,
            trans_send_mail_title: ctrl.get('transSendMailTitle')!.value,
          }
        )
      }
      this.sendMailTitles = sendMailTitles;
      this.dialogRef.close(this.sendMailTitles);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.sendMailTitlesFormGroup.get('autoAllTrans')!.value;
    for (const sendMailTitle of this.sendMailTitlesArrayControl.controls) {
      sendMailTitle.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.sendMailTitlesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const sendMailTitle of this.sendMailTitlesArrayControl.controls) {
      if (!sendMailTitle.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.sendMailTitlesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
